export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
  redirectUri: window.location.origin,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
}